<template>
    <div class="container-fluid">
        <Breadcrumb title="Uploading Log" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group" v-if="this.$store.getters.isAdmin">
                            <label>Source</label>
                            <treeselect placeholder="All"
                                        v-model="filter.source"
                                        :multiple="false"
                                        :options="sourceList"
                                        :load-options="loadSourcesList"
                                        :auto-load-root-options="true"
                            />
                        </div>
                        <div class="form-group">
                            <label class="mb-1">Entries limit:</label>
                            <input v-model="filter.limit" type="text" class="form-control" v-bind:disabled="byDates">
                            <div class="text-danger" v-if="$v.filter.limit.$error">Digest only</div>
                        </div>
                        <div class="form-row">
                            <div class="col-auto">
                                <input v-model="byDates" type="checkbox"
                                       v-bind:true-value="true"
                                       v-bind:false-value="false">
                            </div>
                            <div class="form-group col-lg-2 mb-0">
                                <label>Date range</label>
                                <datetime type="date"
                                          v-bind:disabled="!byDates"
                                          v-model="dateFromComputed"
                                          input-class="form-control"
                                          input-id="from_date"
                                          format="yyyy-MM-dd"
                                          zone="UTC"></datetime>
                            </div>
                            <div class="form-group d-none d-lg-block">
                                <label>&nbsp;</label>
                                <div class="pt-2"><span>-</span></div>
                            </div>
                            <div class="form-group col-lg-2">
                                <label>&nbsp;</label>
                                <datetime type="date"
                                          v-bind:disabled="!byDates"
                                          v-model="dateToComputed"
                                          input-class="form-control"
                                          input-id="to_date"
                                          format="yyyy-MM-dd"
                                          zone="UTC"></datetime>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-2">
                                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light w-100"
                                        @click="getLogEntries()">
                                    Get
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="logEntries.length < 1">{{emptyMessage}}</div>
                            <div v-else class="bg-dark text-white pb-2 pt-3">
                                <ul>
                                    <li v-for="(entry, index) in logEntries" :key="index">
                                        <span :class="{'text-danger': entry.msg_type === 'Error', 'text-warning': entry.msg_type === 'Warning'}">
                                            {{entry.event_time}} | {{entry.source}} | {{entry.msg_type}} #{{entry.msg_text}}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import Swal from 'sweetalert2'
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import {Datetime} from 'vue-datetime';
    import LogService from '../services/LogService';
    import {integer} from 'vuelidate/lib/validators';

    export default {
        name: 'UploadingLog',
        components: {
            Treeselect,
            Breadcrumb,
            Preloader,
            datetime: Datetime
        },
        data() {
            return {
                byDates: false,
                dateFrom: null,
                dateTo: null,
                logEntries: [],
                emptyMessage: 'Select source, dates or limit and get a log.',
                sourceList: null,
                filter: {
                    source: null,
                    limit: 20,
                    dateFrom: null,
                    dateTo: null
                },
                loading: false
            }
        },
        mounted() {
        },
        validations() {
                return {
                    filter: {
                        limit: {integer}
                    }
                }
        },
        methods: {
            loadSourcesList({callback}) {
                LogService.getSourcesList().then(response => {
                    this.sourceList = response.data['sources'].map((source, index) => {
                        return {id: index, label: source}
                    });
                    callback();
                });
            },
            getLogEntries: function () {
                this.loading = true;
                this.filter.dateFrom = this.dateFromComputed;
                this.filter.dateTo = this.dateToComputed;
                LogService.getLogEntries(JSON.stringify(this.filter)).then(response => {
                    if (response.status !== 200) {
                        Swal({
                            type: 'error',
                            title: 'Error',
                            text: (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                        });
                        this.loading = false;
                        return;
                    }
                    this.logEntries = response.data.entries;
                    this.emptyMessage = 'No data found.';
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            },
        },
        computed: {
            dateFromComputed: {
                get(){
                    return this.byDates ? this.dateFrom : null;
                },
                set(newValue){
                    this.dateFrom = newValue;
                }
            },
            dateToComputed: {
                get(){
                    return this.byDates ? this.dateTo : null;
                },
                set(newValue){
                    this.dateTo = newValue;
                }
            },
        }
    }
</script>

<style scoped>

</style>
